import "./Narbar.css";
import { VscTriangleDown, VscTriangleUp } from "react-icons/vsc";
import { IoSettingsSharp, IoNotifications } from "react-icons/io5";
import ProfileCard from "./ProfileCard";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Notification from "../../screens/notification/Notification";
import "../../styles/template.css";
import { MdSpaceDashboard } from "react-icons/md";
import { FaStore } from "react-icons/fa";
import { GiMiner } from "react-icons/gi";
import { IoIosPeople } from "react-icons/io";
import { MdMenuBook } from "react-icons/md";
import { RiBankFill, RiSettings2Fill } from "react-icons/ri";
import { IoCloudOffline } from "react-icons/io5";
import { MdCloudDone } from "react-icons/md";
import { RiDashboardFill } from "react-icons/ri";
import { IoStorefrontSharp } from "react-icons/io5";
import { dropStore } from "../../slice/storeSlice";
import { dropUser } from "../../slice/webStoreUserSlice";
import { clearCart } from "../../slice/sellingCarts";
import { dropWarehouse } from "../../slice/warehouseSlice";
import { dropSelectedMessage } from "../../slice/MessageSlice";
import { BiArrowToLeft } from "react-icons/bi";
import { syncOfflineQueue } from "../../tools/synOfflineQueue";
import { deleteDB } from "../../tools/indexdb";
import { ChevronDown, ChevronUp, Menu, Settings } from "lucide-react";
import StoreNavigation from "./storeNavigiation/StoreNavigation";
import { emptyQueue } from "../../slice/offlineQueue";
import { dropEmployee } from "../../slice/employeeSlice";
import { uiAlert } from "../alerts/customAlert/uiAlert";

const Narbar = () => {
  const [showProfile, setShowProfile] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [isNewNotification, setIsNewNotification] = useState(false); // [TODO
  const [showSetting, setShowSetting] = useState(false);
  const [showStorenavigation, setShowStoreNavigation] = useState(false);
  const [profileImage, setProfileImage] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.webStoreUser);
  const { newNotification } = useSelector((state) => state.notification);
  const { count, _, IsSyncOnGoing } = useSelector((state) => state.offlineQueue);
  const { store } = useSelector((state) => state.store);
  const { employee } = useSelector((state) => state.employee);

  useEffect(() => {
    if (user && Object.keys(user).length > 0 && employee) {
      /*  user.userImage && setProfileImage(user.userImage); */
      employee.employeeImage && setProfileImage(employee.employeeImage);
    }
  }, [user, employee]);

  useEffect(() => {
    console.log(location.pathname);
    location.pathname.includes("/settings") ? setShowSetting(true) : setShowSetting(false);
    //close dropdown when location changes

    if (!location.pathname.includes("stores/")) {
      setShowStoreNavigation(false);
    }
  }, [location]);

  const toggleShowProfile = () => {
    showProfile ? setShowProfile(false) : setShowProfile(true);
  };
  const toggleShowNotification = () => {
    showNotification ? setShowNotification(false) : setShowNotification(true);
  };

  const toggleShowSetting = () => {
    return;
    navigate("/settings/profile");
  };

  const showSideMenuFunc = () => {
    /*     let sideMenu = document.querySelector(".sideMenuWrapper");

    sideMenu.style.transform = "translateX(0)"; */
    let sideMenuWrapper = document.querySelector(".sideMenuWrapper");
    let sideMenu = document.querySelector(".sideMenu984");

    sideMenuWrapper.style.display = "flex";

    setTimeout(() => {
      sideMenu.style.transform = "translateX(0)";
    }, 100);

    /* sideMenu.style.transform = "translateX(0)"; */
  };

  const toogleOpenStoreNavigation = () => {
    showStorenavigation ? setShowStoreNavigation(false) : setShowStoreNavigation(true);
  };

  return (
    <>
      <div className='navBarMain'>
        <div className='logoBurgerIcon33'>
          {
            <div className='burgerIcon22' style={{ justifyContent: "center", alignItems: "center", marginRight: "30px" }} onClick={() => showSideMenuFunc()}>
              <Menu size={34} />
            </div>
          }
          <div className='navBarLogo33'>
            {navBarLogo}
            <p style={{ fontSize: "1.4rem", fontWeight: "600" }}>
              <span style={{ color: "#0E49B5" }}>Store</span>
              <span style={{ color: "#37B4C5" }}>Lense</span>{" "}
            </p>
          </div>
        </div>
        <div className='storeTagNa' style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {<> {count > 0 ? <IoCloudOffline size={20} color='#808080' /> : <MdCloudDone size={20} color='#808080' />}</>}

          {Object.keys(store).length > 0 && <p style={{ fontSize: "0.85rem", fontWeight: "600" }}>{store.storeName}</p>}
        </div>
        <div className='navbarChild'>
          <div>
            {/*    {newNotification ? (
              <div className='highlightedNotification'>
                {" "}
                <IoNotifications onClick={() => setShowNotification(true)} color='gray' size={24} style={{ cursor: "pointer" }} />
                <div></div>
              </div>
            ) : (
              <IoNotifications onClick={() => setShowNotification(true)} color='gray' size={24} style={{ cursor: "pointer" }} />
            )} */}
            {/*   {!showSetting ? (
              <Settings onClick={toggleShowSetting} color='gray' size={22} style={{ cursor: "pointer" }} />
            ) : (
              <div onClick={toggleShowSetting} className='settingsIconNar'>
                {" "}
                <Settings size={22} style={{ cursor: "pointer" }} />
              </div>
            )} */}
          </div>

          {/* <div style={{ height: "20px", width: "1px", backgroundColor: "gray", borderRadius: "40px" }}> </div> */}
        </div>
        <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
          <div className='staffAvartar' onClick={toggleShowSetting}>
            <div>
              {profileImage ? (
                <img src={employee.employeeImage} className='profileImageNar' />
              ) : (
                <div className='profileImagePaces'>{employee?.employeeName[0].toUpperCase()}</div>
              )}
            </div>
            <div>
              <p> {employee?.employeeName.split(" ")[0]}</p>
              {employee?.staffID && <p style={{ fontSize: "0.6rem", color: "gray" }}> {`${employee?.staffID}`}</p>}
            </div>
          </div>
          <div className='notIcon374'>
            {!location.pathname.includes("stores/") ? (
              <p></p>
            ) : (
              <span onClick={toogleOpenStoreNavigation} className='StoreDropDown3664'>
                {showStorenavigation ? <ChevronUp /> : <ChevronDown />}
              </span>
            )}
          </div>
        </div>
      </div>
      {showNotification && <Notification setShowNotification={setShowNotification} />}
      {<SideMenu />}
      {showStorenavigation && <StoreNavigation isOpen={showStorenavigation} onClose={toogleOpenStoreNavigation} />}
    </>
  );
};

export default Narbar;

const SideMenu = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { count, _ } = useSelector((state) => state.offlineQueue);
  const { employee } = useSelector((state) => state.employee);
  const { user } = useSelector((state) => state.webStoreUser);

  const signOut = async () => {
    if (count) {
      console.log(count, "signing out");
      await syncOfflineQueue();
    }
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    dispatch(dropStore());
    dispatch(clearCart());
    dispatch(dropWarehouse());
    navigate("/sign-in");
    dispatch(dropSelectedMessage());
    dispatch(dropUser());
    dispatch(emptyQueue());
    dispatch(dropEmployee());
    deleteDB();

    return;
  };

  const handleClick = (e, path) => {
    if (!user.userIsSubscribed && path !== "/mystores" && path !== "/settings/profile") {
      uiAlert("Your subscription has expired. Please renew your subscription to access this feature.", "warning");
      return;
    }
    if (user.userType.userType.toLowerCase().includes("starter") && path !== "/mystores" && path !== "/settings/profile") {
      uiAlert("Your current plan does not allow access to this feature. Please upgrade your plan to access this feature.", "warning");
      return;
    }
    navigate(path);
    closeMenuFunc();
  };

  const closeMenuFunc = () => {
    let sideMenuWrapper = document.querySelector(".sideMenuWrapper");
    let sideMenu = document.querySelector(".sideMenu984");

    sideMenuWrapper.style.display = "none";
    sideMenu.style.transform = "translateX(-100%)";
    /* sideMenu.style.transform = "translateX(-100%)"; */
  };
  return (
    <>
      <div onClick={() => closeMenuFunc()} className='sideMenuWrapper'>
        <div onClick={(e) => e.stopPropagation()} className='sideMenu984'>
          <div>
            <div style={{ display: "flex" }} className='navBarLogo33 sideMenuLogo'>
              <div>{navBarLogo}</div>
              <div>
                <p style={{ fontSize: "1.4rem", fontWeight: "600" }}>
                  <span style={{ color: "#cbecff" }}>Store</span>
                  <span style={{ color: "#37B4C5" }}>Lense</span> <p style={{ color: "white", fontSize: "0.7rem" }}>Inventory manager</p>
                </p>
              </div>
            </div>
            <div className='StorePlaceholder'>
              <img src='https://res.cloudinary.com/ebuka1122/image/upload/v1781251596/allAssets/StorelenseAd_ddtau0.png' />
            </div>
            <div className={"sideMenu mitag5344"}>
              {/*  <div
                className={location.pathname.includes("/dashboard") ? "clickedOption" : ""}
                onClick={(e) => {
                  if (employee && employee.permissions.dashboard) {
                    handleClick(e, "/dashboard");
                  } else {
                    uiAlert("You do not have access to the dashboard", "error");
                    return;
                  }
                }}
              >
                <MdSpaceDashboard size={22} />

                <span>Dashboard</span>
              </div> */}

              <div
                className={location.pathname.includes("/mystores") ? "clickedOption" : ""}
                onClick={(e) => {
                  handleClick(e, "/mystores");
                  dispatch(dropStore());
                  dispatch(clearCart());
                  dispatch(dropWarehouse());
                  dispatch(dropSelectedMessage());
                }}
              >
                <FaStore size={20} />
                <span>Stores</span>
              </div>
              {/* <div className={location.pathname === "/employees" ? "clickedOption" : ""} onClick={(e) => handleClick(e, "/employees")}>
                <GiMiner size={22} />
                <span>Employees</span>
              </div> */}
              <div
                className={location.pathname === "/customers" ? "clickedOption" : ""}
                onClick={(e) => {
                  if (employee && employee.permissions?.customers) {
                    handleClick(e, "/customers");
                  } else {
                    uiAlert("You do not have access to customers", "error");
                    return;
                  }
                }}
              >
                <IoIosPeople size={22} />
                <span>Customers</span>
              </div>
              {/*   <div
                className={location.pathname === "/sales-record" ? "clickedOption" : ""}
                onClick={(e) => {
                  if (employee && employee.permissions.salesRecords) {
                    handleClick(e, "/sales-record");
                  } else {
                    uiAlert("You do not have access to sales record", "error");
                    return;
                  }
                }}
              >
                <MdMenuBook size={20} />
                <span>Sales record</span>
              </div> */}
              {/*  <div className={location.pathname === "/payout" ? "clickedOption" : ""} onClick={(e) => handleClick(e, "/payout")}>
                <RiBankFill size={20} />
                <span>Payouts</span>
              </div> */}
              {/* <div
                id={"u4jnkasdo"}
                className={location.pathname === "/settings/profile" ? "clickedOption" : ""}
                onClick={(e) => {
                  handleClick(e, "/settings/profile");
                }}
              >
                <RiSettings2Fill size={20} />
                <span>Settings</span>
              </div> */}
            </div>
          </div>
          <div className='signOutDiv'>
            <div></div>
            <div className='reWo4635' onClick={() => signOut()}>
              <BiArrowToLeft size={20} />
              <span>Sign out</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const BurgerMenuIcon = () => {
  return (
    /*  <svg xmlns='http://www.w3.org/2000/svg' xlink='http://www.w3.org/1999/xlink' width='72' height='50' viewBox='0 0 72 65'>
      <defs>
        <filter id='Rectangle_2064' x='0' y='0' width='72' height='65' filterUnits='userSpaceOnUse'>
          <feOffset dy='3' input='SourceAlpha' />
          <feGaussianBlur stdDeviation='3' result='blur' />
          <feFlood flood-opacity='0.161' />
          <feComposite operator='in' in2='blur' />
          <feComposite in='SourceGraphic' />
        </filter>
      </defs>
      <g id='Group_2616' data-name='Group 2616' transform='translate(-8120 -9039)'>
        <g transform='matrix(1, 0, 0, 1, 8120, 9039)' filter='url(#Rectangle_2064)'>
          <rect id='Rectangle_2064-2' data-name='Rectangle 2064' width='54' height='47' rx='5' transform='translate(9 6)' fill='#fff' />
        </g>
        <g id='Group_2615' data-name='Group 2615' transform='translate(13 -28)'>
          <path
            id='Rectangle_2062'
            data-name='Rectangle 2062'
            d='M0,0H32a0,0,0,0,1,0,0V0a3,3,0,0,1-3,3H3A3,3,0,0,1,0,0V0A0,0,0,0,1,0,0Z'
            transform='translate(8127 9103)'
            fill='#515151'
          />
          <path
            id='Rectangle_2065'
            data-name='Rectangle 2065'
            d='M3,0H29a3,3,0,0,1,3,3V3a0,0,0,0,1,0,0H0A0,0,0,0,1,0,3V3A3,3,0,0,1,3,0Z'
            transform='translate(8127 9087)'
            fill='#515151'
          />
          <rect id='Rectangle_2066' data-name='Rectangle 2066' width='32' height='3' rx='1.5' transform='translate(8127 9095)' fill='#515151' />
        </g>
      </g>
    </svg> */
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='40'
      height='30'
      viewBox='0 0 30 30'
      fill='none'
      stroke='currentColor'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
      class='lucide lucide-menu-icon lucide-menu'
    >
      <path d='M4 12h16' />
      <path d='M4 18h16' />
      <path d='M4 6h16' />
    </svg>
  );
};

export const navBarLogo = (
  <svg xmlns='http://www.w3.org/2000/svg' xlink='http://www.w3.org/1999/xlink' width='40' height='40' viewBox='0 0 47 47'>
    <defs>
      <filter id='Ellipse_272'>
        <feOffset dx='-1' dy='1' input='SourceAlpha' />
        <feGaussianBlur stdDeviation='5' result='blur' />
        <feFlood flood-color='#0f0f0f' flood-opacity='0.161' result='color' />
        <feComposite operator='out' in='SourceGraphic' in2='blur' />
        <feComposite operator='in' in='color' />
        <feComposite operator='in' in2='SourceGraphic' />
      </filter>
      <filter id='Ellipse_274' x='0' y='0' width='47' height='47' filterUnits='userSpaceOnUse'>
        <feOffset dy='3' input='SourceAlpha' />
        <feGaussianBlur stdDeviation='3' result='blur-2' />
        <feFlood flood-opacity='0.161' />
        <feComposite operator='in' in2='blur-2' />
        <feComposite in='SourceGraphic' />
      </filter>
      <radialGradient
        id='radial-gradient'
        cx='0.862'
        cy='0.237'
        r='1.394'
        gradientTransform='translate(-0.13 0.179) rotate(-17.999)'
        gradientUnits='objectBoundingBox'
      >
        <stop offset='0' stop-color='#5070a1' />
        <stop offset='1' stop-color='#0e49b5' />
      </radialGradient>
      <filter id='Subtraction_13' x='0.568' y='1.07' width='28.944' height='28.861' filterUnits='userSpaceOnUse'>
        <feOffset dx='-3' input='SourceAlpha' />
        <feGaussianBlur stdDeviation='3' result='blur-3' />
        <feFlood flood-color='#434343' flood-opacity='0.161' />
        <feComposite operator='in' in2='blur-3' />
        <feComposite in='SourceGraphic' />
      </filter>
      <filter id='Subtraction_23' x='15.125' y='15.462' width='28.862' height='28.413' filterUnits='userSpaceOnUse'>
        <feOffset dy='3' input='SourceAlpha' />
        <feGaussianBlur stdDeviation='3' result='blur-4' />
        <feFlood flood-color='#464646' flood-opacity='0.161' />
        <feComposite operator='in' in2='blur-4' />
        <feComposite in='SourceGraphic' />
      </filter>
    </defs>
    <g id='Group_2614' data-name='Group 2614' transform='translate(-5599.81 -10623.81)'>
      <g data-type='innerShadowGroup'>
        <circle id='Ellipse_272-2' data-name='Ellipse 272' cx='20' cy='20' r='20' transform='translate(5602.81 10624.811)' fill='#fff' />
        <g transform='matrix(1, 0, 0, 1, 5599.81, 10623.81)' filter='url(#Ellipse_272)'>
          <circle id='Ellipse_272-3' data-name='Ellipse 272' cx='20' cy='20' r='20' transform='translate(3 1)' fill='#fff' />
        </g>
        <g id='Ellipse_272-4' data-name='Ellipse 272' transform='translate(5602.81 10624.811)' fill='none' stroke='#0e49b5' stroke-width='2'>
          <circle cx='20' cy='20' r='20' stroke='none' />
          <circle cx='20' cy='20' r='19' fill='none' />
        </g>
      </g>
      <circle id='Ellipse_273' data-name='Ellipse 273' cx='15' cy='15' r='15' transform='translate(5607.81 10629.811)' fill='#c8a027' />
      <g transform='matrix(1, 0, 0, 1, 5599.81, 10623.81)' filter='url(#Ellipse_274)'>
        <circle id='Ellipse_274-2' data-name='Ellipse 274' cx='14.5' cy='14.5' r='14.5' transform='translate(9 6)' fill='#fff' />
      </g>
      <g id='Group_2610' data-name='Group 2610' transform='translate(5611.881 10633.881)'>
        <g transform='matrix(1, 0, 0, 1, -12.07, -10.07)' filter='url(#Subtraction_13)'>
          <path
            id='Subtraction_13-2'
            data-name='Subtraction 13'
            d='M10.943,10.862H0A10.554,10.554,0,0,1,3.19,3.326,11.63,11.63,0,0,1,10.944,0V10.861h0Z'
            transform='translate(12.57 10.07)'
            fill='url(#radial-gradient)'
          />
        </g>
        <path
          id='Subtraction_25'
          data-name='Subtraction 25'
          d='M10.8,0H0A10.623,10.623,0,0,0,3.148,7.536,11.406,11.406,0,0,0,10.8,10.862V0h0Z'
          transform='translate(22.854 10.862) rotate(180)'
          fill='#37b4c5'
        />
        <path
          id='Subtraction_17'
          data-name='Subtraction 17'
          d='M10.412,10.862H0A10.87,10.87,0,0,1,10.413,0V10.861h0Z'
          transform='translate(0.58 21.805) rotate(-90)'
          fill='#37b4c5'
        />
        <g transform='matrix(1, 0, 0, 1, -12.07, -10.07)' filter='url(#Subtraction_23)'>
          <path
            id='Subtraction_23-2'
            data-name='Subtraction 23'
            d='M10.412,0H0A10.825,10.825,0,0,0,3.035,7.536a10.813,10.813,0,0,0,7.378,3.325V0h0Z'
            transform='translate(24.12 31.88) rotate(-90)'
            fill='#0e49b5'
          />
        </g>
        <path
          id='Subtraction_12'
          data-name='Subtraction 12'
          d='M22.232,0H0A10.218,10.218,0,0,0,3.405,7.138a11.416,11.416,0,0,0,7.711,2.936,11.416,11.416,0,0,0,7.711-2.936A10.217,10.217,0,0,0,22.232,0Z'
          transform='translate(23.528 10.636) rotate(180)'
          fill='#fff'
        />
        <path
          id='Subtraction_26'
          data-name='Subtraction 26'
          d='M22.232,10.075H0A10.218,10.218,0,0,1,3.4,2.936,11.416,11.416,0,0,1,11.116,0a11.415,11.415,0,0,1,7.711,2.936,10.218,10.218,0,0,1,3.4,7.138Z'
          transform='translate(22.232 21.268) rotate(180)'
          fill='#fff'
        />
        <path id='Path_3551' data-name='Path 3551' d='M0,0H22.416' transform='translate(0.499 11.014)' fill='none' stroke='#0e49b5' stroke-width='1' />
      </g>
    </g>
  </svg>
);
